module.exports = __webpack_public_path__ + "static/media/imago500kz.77df1f32.pdf";